import { REGEX } from '@/constants/regex';

export function camelCase(str = '') {
  return str
    .replace(
      REGEX.CAMEL_CASE_WORD_BOUNDARIES,
      function (word: string, index: number) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      },
    )
    .replace(REGEX.WHITESPACE, '');
}

export function kebabCase(string = '') {
  return string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const titleCase = (text: string | null) => {
  return !text ? '' : text.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
};
